import React, { useEffect, useRef, useState } from 'react';

const DEPLOYMENT_NAME =
  'projects/kloud-pilot/locations/us/apps/0664a359-a283-4b46-b781-67f9ce6de91b/deployments/98bb0933-2e54-413b-b645-2168852b6c13';

const CHAT_SDK_SRC =
  'https://www.gstatic.com/chat-messenger/sdk/prod/v1.16/chat-messenger.js';

const CHAT_DEFAULT_CSS =
  'https://www.gstatic.com/chat-messenger/sdk/prod/v1.16/themes/chat-messenger-default.css';

const CHAT_LAYOUT_CSS =
  'https://www.gstatic.com/chat-messenger/sdk/prod/v1.16/themes/chat-messenger-layout.css';

export default function VentasAgentPage() {
  const [sdkReady, setSdkReady] = useState(false);
  const contextRegisteredRef = useRef(false);

  useEffect(() => {
    const loadStylesheet = (href) => {
      const existing = document.querySelector(`link[href="${href}"]`);
      if (existing) return;

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
    };

    loadStylesheet(CHAT_DEFAULT_CSS);
    loadStylesheet(CHAT_LAYOUT_CSS);

    const handleLoaded = () => {
      setSdkReady(true);
    };

    window.addEventListener('chat-messenger-loaded', handleLoaded);

    const existingScript = document.querySelector(`script[src="${CHAT_SDK_SRC}"]`);

    if (!existingScript) {
      const script = document.createElement('script');
      script.defer = true;
      script.src = CHAT_SDK_SRC;
      document.head.appendChild(script);
    } else if (window.chatSdk) {
      setSdkReady(true);
    }

    return () => {
      window.removeEventListener('chat-messenger-loaded', handleLoaded);
    };
  }, []);

  useEffect(() => {
    if (!sdkReady) return;
    if (!window.chatSdk) return;
    if (contextRegisteredRef.current) return;

    window.chatSdk.registerContext(
      window.chatSdk.prebuilts.ces.createContext({
        deploymentName: DEPLOYMENT_NAME,
        tokenBroker: {
          enableTokenBroker: true,
          enableRecaptcha: false,
        },
      })
    );

    contextRegisteredRef.current = true;
  }, [sdkReady]);

  return (
    <div className="ventas-agent-page">
      <div className="ventas-agent-shell">
        <div className="ventas-agent-header">
          <p className="ventas-agent-eyebrow">Ventas</p>

          <h1 className="ventas-agent-title">
            Agente Comercial
          </h1>

          <p className="ventas-agent-description">
            Consulta información comercial, propuestas, servicios y lineamientos de apoyo para conversaciones con clientes.
          </p>
        </div>

        <section className="ventas-agent-card">
          <div className="ventas-agent-glow" />

          <div className="ventas-agent-content">
            <div className="ventas-agent-chat-wrapper">
              <chat-messenger
                url-allowlist="*"
                color-scheme="dark"
                intent="WELCOME"
                max-query-length="-1"
              >
                <chat-messenger-container
                  chat-title="Kloud Pilot Sales"
                  chat-title-icon="https://gstatic.com/dialogflow-console/common/assets/ccai-favicons/conversational_agents.png"
                  enable-file-upload
                  enable-audio-input
                >
                  <chat-reset-session-button
                    slot="titlebar-actions"
                    title-text="Start new chat"
                  ></chat-reset-session-button>

                  <chat-toggle-dialog-button
                    slot="titlebar-actions"
                    title-text-expanded="Collapse"
                    title-text-collapsed="Expand"
                  ></chat-toggle-dialog-button>

                  <chat-messenger-close-button
                    slot="titlebar-actions"
                    title-text="Close"
                  ></chat-messenger-close-button>
                </chat-messenger-container>
              </chat-messenger>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}